import { createAction } from '@ngrx/store';

export const freeTrialPageActions = {
  userClickedDownloadReport: createAction('[Free Trial Report] User Clicked Download Report')
};

export const freeTrialApiActions = {
  loadFreeTrialReportSuccess: createAction('[Free Trial Report API] Load Free Trial Report Success'),
  loadFreeTrialReportFailure: createAction('[Free Trial Report API] Load Free Trial Report Failure')
};
